<template>
    <v-dialog
        v-model="modalIsActive"
        attach="#app"
        overlay-color="#000"
        :overlay-opacity="0.8"
        width="400"
    >
        <div v-if="modalIsActive" class="client-delete__body">
            <h3 class="client-delete__title">{{ getMessage }}</h3>

            <v-divider></v-divider>

            <div class="client-delete__actions">
                <v-btn
                    min-width="85"
                    class="client-delete__btn"
                    small
                    :color="confirmColor ? confirmColor : '#3bafda'"
                    dark
                    data-test-id="shared--confirmer--submit-btn"
                    @click="agreeHandle"
                >
                    {{ confirmText ? confirmText : textContent.btn_yes }}
                </v-btn>
                <v-btn
                    min-width="85"
                    class="client-delete__btn"
                    small
                    :color="cancelColor ? cancelColor : '#da4453'"
                    dark
                    data-test-id="shared--confirmer--cancel-btn"
                    @click="cancelHandle"
                    >{{ cancelText ? cancelText : textContent.btn_no }}
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import confirmMixin from '@/mixins/confirm.mixin'
import languageMixin from '@/mixins/language.mixin'

export default {
    name: 'Confirmer',
    mixins: [confirmMixin, languageMixin],
}
</script>

<style scoped lang="scss">
.client-delete {
    &__title {
        text-align: center;
        margin-bottom: 15px;
    }

    &__body {
        height: fit-content;
        background: $color-primary-light;
        padding: 30px 15px 0;
    }

    &__actions {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
    }

    &__btn {
        min-width: 85px;
    }
}
</style>
